import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";

// Corporate Pages
import Homepage from './pages/homepage';
import AboutPage from './pages/about';
import CorporateStructurePage from './pages/corporate-structure';
import TechnologyPage from './pages/technology';
import ImpactPage from './pages/impact';
import InvestorRelationsPage from './pages/investor-relations';
import PartnershipsPage from './pages/partnerships';
import CompliancePage from './pages/compliance';
import PressPage from './pages/press';
import CareersPage from './pages/careers';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Main Corporate Pages */}
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />

          {/* Company */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/about-united-empresas" element={<AboutPage />} />
          <Route path="/corporate-structure" element={<CorporateStructurePage />} />
          <Route path="/careers" element={<CareersPage />} />

          {/* Technology */}
          <Route path="/technology" element={<TechnologyPage />} />
          <Route path="/platform-overview" element={<TechnologyPage />} />

          {/* Impact */}
          <Route path="/impact" element={<ImpactPage />} />

          {/* Investors & Partners */}
          <Route path="/investor-relations" element={<InvestorRelationsPage />} />
          <Route path="/partnerships" element={<PartnershipsPage />} />
          <Route path="/contact-partnerships" element={<PartnershipsPage />} />

          {/* Compliance & Legal */}
          <Route path="/compliance" element={<CompliancePage />} />

          {/* Press & Media */}
          <Route path="/press" element={<PressPage />} />

          {/* Legacy routes - redirect to new pages */}
          <Route path="/market-expansion-hub" element={<AboutPage />} />
          <Route path="/vendor-success-hub" element={<ImpactPage />} />
          <Route path="/support-center" element={<CompliancePage />} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
